// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ToolTwoToneSvg from "@ant-design/icons-svg/es/asn/ToolTwoTone";
import AntdIcon from '../components/AntdIcon';

var ToolTwoTone = function ToolTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ToolTwoToneSvg
  }));
};

ToolTwoTone.displayName = 'ToolTwoTone';
export default React.forwardRef(ToolTwoTone);